<template>
  <ngc-accordion-group multiple>
    <ngc-accordion
      v-for="(permissionGroup, groupIndex) in permissionGroups"
      :key="groupIndex + '-group'"
      :title="permissionGroup.name"
      :is-expanded.prop="isGroupExpanded(groupIndex)"
      :data-cy="groupDataCy(permissionGroup.name)"
      @toggle-expand="toggleGroup(groupIndex)"
    >
      <div
        slot="content"
        class="permission-group__content"
      >
        <sr-permission-row
          v-for="(setting, rowIndex) in permissionGroup.settings"
          :key="groupIndex + '-' + rowIndex + '-row'"
          :data-cy="rowDataCy(setting.display_name)"
          :permission="setting"
          :view-only="viewOnly"
          class="permission-row item-border-bottom"
          @permissionChange="handleChange($event)"
        />
      </div>
    </ngc-accordion>
  </ngc-accordion-group>
</template>

<script>

import srPermissionRow from './srPermissionRow'
import _ from 'lodash'

export default {
  name: 'SrPermissionGroups',
  components: {
    srPermissionRow
  },
  props: {
    permissionGroups: {
      type: Array,
      required: true
    },
    viewOnly: {
      type: Boolean,
      required: false,
      default: false
    },
    expanded: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      expandedGroups: {}
    }
  },
  watch: {
    expanded (val) {
      this.expandAll(val)
    }
  },
  created () {
    this.expandAll(this.expanded)
  },
  methods: {
    expandAll (expanded) {
      const groups = {}
      this.permissionGroups.forEach((_group, index) => {
        groups[index] = expanded
      })
      this.expandedGroups = groups
    },
    isGroupExpanded (index) {
      return !!this.expandedGroups[index]
    },
    toggleGroup (index) {
      this.$set(this.expandedGroups, index, !this.expandedGroups[index])
    },
    handleChange (changedPermissions) {
      this.$emit('permissionChange', changedPermissions)
    },
    groupDataCy (groupName) {
      return `permission-${_.kebabCase(groupName).toLowerCase()}`
    },
    rowDataCy (settingName) {
      return `permission-${_.kebabCase(settingName).toLowerCase()}`
    }
  }
}
</script>

<style lang="scss" scoped>

.permission-row {
  margin: 0;
}

.permission-group__content {
  margin-top: -16px;
}

</style>
